import { EDIT_GROUP_METADATA_REQUEST, EDIT_GROUP_METADATA_REQUEST_FAILURE } from '../constants/edit_group_data.constants';

export const editGroupMetaDataRequest = (_id, params) => ({ type: EDIT_GROUP_METADATA_REQUEST, _id, params });
export const editGroupMetaDataRequestFailure = error => ({ type: EDIT_GROUP_METADATA_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/redux/actions/edit_group_meta_data.actions.js